var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.formatted_date_value,"placement":"bottom"}},[_c('span',[_vm._v(_vm._s(_vm.prefixMessage)+" "+_vm._s(_vm.fromNow))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }